import {email, password, required} from '../units';
import validate from '../common';

const validations = isUsernameEmail => {
  const common = {
    password: [required(), password()]
  };

  if (isUsernameEmail) {
    return {
      ...common,
      email: [required(), email()]
    };
  }

  return {
    ...common,
    username: [required()]
  };
};

export default isUsernameEmail => ({
  validate: validate(validations(isUsernameEmail))
});



// WEBPACK FOOTER //
// ./validators/forms/central.js